import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';

export const createTelegramChannels = createAsyncThunk(
  'channelReducer/createTelegramChannels',
  async (payload, thunkAPI) => {
    const channelState = thunkAPI.getState().channelReducer;

    const params = {
      title: channelState.title,
      username: channelState.username,
      type: 'channel',
    };

    try {
      const response = await apiPost('/alarm/telegram_channels', params);
      return {
        id: response?.data?.result?.id,
        title: channelState.title,
        username: channelState.username,
        type: 'channel',
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getTelegramChannels = createAsyncThunk(
  'channelReducer/getTelegramChannels',
  async (payload, thunkAPI) => {
    try {
      const response = await apiGet('/alarm/telegram_channels');
      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const validateBaleChannel = createAsyncThunk(
  'channelReducer/validateBaleChannel',
  async (payload, thunkAPI) => {
    const channelState = thunkAPI.getState().channelReducer;

    let bale_channel = channelState.title;

    if (!bale_channel?.includes('@')) bale_channel = `@${bale_channel}`;

    try {
      await apiGet('/alarm/stories/validate-bale', {
        bale_channel,
      });
      return channelState.title;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  title: '',
  username: '',
  telegramChannels: {
    data: [],
    loading: false,
    error: null,
  },
  baleChannels: {
    data: [],
    loading: false,
    error: null,
  },
  contact: {
    data: [],
    loading: false,
    error: null,
  },
};

export const channelSlice = createSlice({
  name: 'channelSlice',
  initialState,
  reducers: {
    setChannelParamValue: (state, action) => {
      state[action.payload?.param] = action.payload?.value;
    },
    setBaleChannel: (state, action) => {
      state.baleChannels.data = [action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTelegramChannels.fulfilled, (state, action) => {
        state.telegramChannels.loading = initialState.loading;
        state.telegramChannels.error = initialState.error;

        state.telegramChannels.data = [
          ...state.telegramChannels.data,
          action.payload,
        ];
      })
      .addCase(createTelegramChannels.pending, (state) => {
        state.telegramChannels.loading = true;
        state.telegramChannels.error = null;
      })
      .addCase(createTelegramChannels.rejected, (state, action) => {
        state.telegramChannels.loading = false;
        state.telegramChannels.error = action.payload;
      })
      .addCase(getTelegramChannels.fulfilled, (state, action) => {
        state.telegramChannels.loading = false;
        state.telegramChannels.error = null;
        state.telegramChannels.data = action.payload;
      })
      .addCase(getTelegramChannels.pending, (state) => {
        state.telegramChannels.loading = true;
        state.telegramChannels.error = null;
      })
      .addCase(getTelegramChannels.rejected, (state, action) => {
        state.telegramChannels.loading = false;
        state.telegramChannels.error = action.payload;
      })
      .addCase(validateBaleChannel.fulfilled, (state, action) => {
        if (!state.baleChannels.data.find((item) => item === action.payload))
          state.baleChannels.data = [
            ...state.baleChannels.data,
            action.payload,
          ];
        state.baleChannels.loading = false;
        state.baleChannels.error = null;
      })
      .addCase(validateBaleChannel.pending, (state) => {
        state.baleChannels.loading = true;
        state.baleChannels.error = null;
      })
      .addCase(validateBaleChannel.rejected, (state, action) => {
        state.baleChannels.loading = false;
        state.baleChannels.error = action.payload;
      });
  },
});

export const { setChannelParamValue, setBaleChannel } = channelSlice.actions;
